import type { CatalogAvailability, ClientProfile, Colleague, Kip } from '@/types';

export function catalogStatusLabel(status: CatalogAvailability): string {
  switch (status) {
    case 'available':
      return 'Available';
    case 'draft':
      return 'Draft';
    case 'coming_soon':
      return 'Coming soon';
  }
}

export function isLearnerKipPlayable(
  kip: Kip,
  clients: ClientProfile[],
  colleagues: Colleague[],
  isAdmin: boolean,
): boolean {
  if (isAdmin) return true;
  if (kip.availability !== 'available') return false;
  if (kip.client) {
    return kip.client.availability === 'available';
  }
  if (kip.colleagueId) {
    const colleague = colleagues.find((c) => c.id === kip.colleagueId);
    if (!colleague || colleague.availability !== 'available') return false;
  }
  return true;
}

/** Kips that are not learner-visible at all (admins still see them in admin tools). */
export function filterDraftKipsOutForLearner(kips: Kip[], isAdmin: boolean): Kip[] {
  if (isAdmin) return kips;
  return kips.filter((k) => k.availability !== 'draft');
}

export function filterDraftClientsOutForLearner(clients: ClientProfile[], isAdmin: boolean): ClientProfile[] {
  if (isAdmin) return clients;
  return clients.filter((c) => c.availability !== 'draft');
}

export function filterDraftColleaguesOutForLearner(colleagues: Colleague[], isAdmin: boolean): Colleague[] {
  if (isAdmin) return colleagues;
  return colleagues.filter((c) => c.availability !== 'draft');
}

export function generalWorldCatalogStatus(scenarioKips: Kip[]): CatalogAvailability {
  const visible = scenarioKips.filter((k) => k.availability !== 'draft');
  if (visible.length === 0) return 'coming_soon';
  if (visible.some((k) => k.availability === 'available')) return 'available';
  return 'coming_soon';
}
